/**
 * Validates if a value is a string with content (ignoring surrounding spaces)
 * @param value - Value to be validated
 * @returns true if the value is a non-empty string, false otherwise
 */
export const isNonEmptyString = <T>(value: T): value is T & string =>
  typeof value === 'string' && value.trim() !== '';
